import React, { FC } from 'react';
import Picture from '../../../@shared/picture';
import { TPictureBlock } from '../../types/productModelsListing.types';

const PictureBlock: FC<TPictureBlock> = ({ asset }) => {
  if (!asset) return null;
  return (
    <Picture
      productImageProps={{
        desktopRendition: asset.rendition_desktop_size500,
        mobileRendition: asset.rendition_mobile_size500,
        pictureClassName: 'product-card__picture--fixed-aspect-ratio',
        imageClassName: 'product-card__image',
        alt: asset.alt,
      }}
    />
  );
};

export default PictureBlock;
